module.exports = __webpack_public_path__ + "img/selected6-min.3198723e.png";